import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Helmet from 'react-helmet';

import Basic from './apps/Basic';
const apps = {
    Basic: Basic
};

class AppIndex extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			app:{},
			isLoading:true
		}
		this.setApp = this.setApp.bind(this);
	}

	setApp(app) {
		this.setState({app:app,isLoading:false});
	}

	componentWillMount() {
		axios.get('/apps/'+this.props.router.params.app)
		.then(res => {
			this.setApp(res.data);
		});
	}

	render() {

		if(this.state.isLoading) {
			return <Loading error={false} />
		}
		const comp = this.state.app.template ? this.state.app.template:this.props.router.params.app;
		const AppComponent = apps[comp];

		return (
			<div className="full-height">
				<Helmet title="Apps | Crall.io" />

				<div className="page-header">
					<span className="page-title"><i className="icon wb-extension"></i> Apps</span>
				</div>

				<div className="page-content">
					<AppComponent setApp={this.setApp} app={this.state.app} />
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


AppIndex = connect(mapStateToProps,mapDispatchToProps)(AppIndex);
export default AppIndex;


// WEBPACK FOOTER //
// ./containers/apps/AppIndex.js